import {ReactNode} from 'react';
import {DialogTitle} from '@mui/material';

export default function FullScreenModalTitle({children}: {children: ReactNode}) {
  return (
    <DialogTitle
      variant="h6"
      sx={{
        flex: 1,
        position: 'relative',
        backgroundColor: 'secondary.light',
        boxShadow: 'none',
        color: 'text.secondary',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}
    >
      {children}
    </DialogTitle>
  );
}
